import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Account() {
  const { user, setUser, money } = useApp();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user === false) { navigate("/login"); return; }
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  }, [user]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
    toast.success("You have been signed out.");
    navigate("/");
  };

  if (!user) return <div className="h-[60vh]" />;

  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <div className="flex items-center justify-between mb-12">
        <div>
          <h1 className="font-serif text-4xl">Welcome, {user.name?.split(" ")[0]}</h1>
          <p className="text-sm mt-1" style={{ color: "var(--ev-muted)" }}>{user.email}</p>
        </div>
        <div className="flex gap-3">
          {user.role === "admin" && <button onClick={() => navigate("/admin")} className="btn-luxe">Admin Panel</button>}
          <button data-testid="account-logout" onClick={logout} className="text-sm ev-link" style={{ color: "var(--ev-muted)" }}>Sign Out</button>
        </div>
      </div>

      <h2 className="eyebrow mb-6">Order History</h2>
      {orders.length === 0 ? (
        <div className="border p-12 text-center" style={{ borderColor: "var(--ev-border)" }}>
          <p className="font-serif text-2xl mb-2">No orders yet</p>
          <p className="text-sm mb-6" style={{ color: "var(--ev-muted)" }}>Your Maison Évaren purchases will appear here.</p>
          <button onClick={() => navigate("/")} className="btn-luxe">Discover the Collections</button>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border p-6" style={{ borderColor: "var(--ev-border)" }}>
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                  <span className="font-serif text-lg">{o.order_number}</span>
                  <span className="ml-3 text-xs uppercase tracking-wider px-2 py-1" style={{ background: "var(--ev-bg)", color: "var(--ev-muted)" }}>{o.status}</span>
                </div>
                <span className="font-serif text-lg">{money(o.total_usd)} {o.currency}</span>
              </div>
              <div className="flex gap-2 mt-4">
                {o.items.map((it, i) => <img key={i} src={it.image} alt="" className="w-12 h-16 object-cover" />)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
